import React from 'react';
import { usePagination } from './usePagination';
import { LeftArrow, RightArrow } from '../../../icons';

const Pagination = ({
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
  from = '',
  to = '',
  onPageChange,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <div className="flex max-lg:flex-col items-center gap-6 justify-center py-2 max-lg:pb-28">
      <div className="text-disclaimer order-2 lg:order-1">
        Εμφάνιση {from} έως {to} από {totalCount} εγγραφές
      </div>
      <nav
        className="flex gap-2 items-center justify-center order-1 lg:order-2"
        aria-label="Pagination"
      >
        <button
          className={`min-w-[32px] h-8 p-2 text-link rounded-sm ${
            currentPage === 1 ? 'bg-fadedgrey' : 'bg-white'
          }  `}
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <LeftArrow
            className={`h-3 ${
              currentPage === 1 ? 'stroke-white' : 'stroke-black'
            }`}
          />
        </button>
        {paginationRange.map((pageNumber, index) => {
          if (pageNumber === '...') {
            return (
              <li key={`${pageNumber}_${index}`} className="list-none">
                {'...'}
              </li>
            );
          }

          return (
            <button
              key={pageNumber}
              className={`min-w-[32px] h-8 p-2 text-link rounded-sm bg-white ${
                currentPage === pageNumber
                  ? 'border border-primary'
                  : 'border border-mildgrey'
              }`}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </button>
          );
        })}
        <button
          className={`min-w-[32px] h-8 p-2 text-link rounded-sm  ${
            currentPage === lastPage ? 'bg-fadedgrey' : 'bg-white'
          }`}
          disabled={currentPage === lastPage}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <RightArrow
            className={`h-3 ${
              currentPage === lastPage ? 'stroke-white' : 'stroke-black'
            }`}
          />
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
